import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import { ThreeDots } from 'react-loader-spinner';
import { updateserviceLength, addServiceLength, resetList } from "../../3.Store/ServiceLengthsSlice";

const ServiceLengthAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(state => state.ServiceLengthsSlice.loading);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const serviceLength = useSelector(state => state.ServiceLengthsSlice.serviceLength);
  const { id, description, short_description } = serviceLength;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBtnAdd = () => {
    if (id.length !== 2) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "ID must be only 2 characters",
        confirmButtonColor: "#4fa94d",
      });
      return;
    }
    const entity = { ...serviceLength, short_description: description };
    console.log(entity);
    dispatch(addServiceLength(entity))
      .unwrap()
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Service Length added successfully",
          confirmButtonColor: "#4fa94d",
        }).then(() => {
          dispatch(resetList());
          navigate("/ServiceLengths");
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: (error.response.data || error.message),
          confirmButtonColor: "#4fa94d",
        });
      });
  };

  const handleBtnBack = () => {
    dispatch(resetList());
    navigate("/ServiceLengths");
  };

  const handleUpdate = (e) => {
    let value = e.target.value;
    if (e.target.name === "id") {
      value = value.toUpperCase();
    }
    const entity = { ...serviceLength, [e.target.name]: value };
    console.log(entity);
    dispatch(updateserviceLength(entity));
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Service Length</h1>
        <h1 className="MiniTitleHeader">Add</h1>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">ID</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="id" value={id} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Description</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="description" value={description} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnAdd}>
              Add
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};

export default ServiceLengthAdd;